import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod/mini"

export const Route = createFileRoute("/auth/error")({
  component: RouteComponent,
  validateSearch: z.object({
    error: z.string(),
    error_description: z.string(),
  }),
})

function RouteComponent() {
  const { error, error_description } = Route.useSearch()

  return (
    <div>
      <div>{error}</div>
      <div>{error_description.split("+").join(" ")}</div>
    </div>
  )
}
